import React, { useEffect, useState ,useMemo} from "react";
import { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, MenuItem, Select, FormControl } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {
    Button,
    Checkbox,
    ListItemText,
    Chip, TextField
} from "@material-ui/core";
import Spacer from "../../components/Spacer";
import { userDetailContext } from "../../App";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import { useNavigate, useLocation } from 'react-router-dom';
import BalanceConfigurationService from "../../services/BalanceConfigurationService";
import { GetAppTwoTone } from "@material-ui/icons";
import FileService from "../../services/FileService";
import * as FileSaver from "file-saver";
import * as XLSX from 'xlsx';
import UserService from "../../services/UserService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PlanningMissionService from "../../services/PlanningMissionService";
import ListBalance from "./ListBalance";
import { headerData } from "../../data/modules/dashboard-header";
import { headerEtat } from "../../data/modules/etat_header";
import MainContainer from "../../components/MainContainer";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        elevation: 0,
    },
}));
function Balancehistory(props) {

            const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const navigate = useNavigate();
            const location = useLocation();
            const [rows, setRows] = useState([]);
            const [value, setValue] = useState(1);
            const [userId, setUserId] = useState("");
            const [IsUpperHierarchy, setIsUpperHierarchy] = useState(false);
            const [listOfSubordonnate, setListOfSubordonnate] = useState([]);
            const [detailListOfSubordonnate, setDetailListOfSubordonnate] = useState([]);
            const [specificListOfSubordonnate, setSpecificListOfSubordonnate] = useState([]);
            const [serviceName, setServiceName] = useState("");
            const [initialBalance, setinitialBalance] = useState("");
            const [initialBalancedate, setinitialBalancedate] = useState("");
            const [initialBalancedateFormat, setinitialBalancedateFormat] = useState("");
            const [actualBalance, setactualBalance] = useState("");
            const contextData = useContext(userDetailContext);
            const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
            const classes = useStyles();
            const [direction,setDirection]=useState([]);
            const [selectedDirection, setSelectedDirection] = useState(null);
        
            function getInitialActualBalance() {
                BalanceConfigurationService.getUserConnectedBalanceDetail().then((res) => {
                    console.log(res.data)
                    if (res && res.status) {
                        console.log(res.data);
                        setinitialBalance(res.data.initialBalance);
                        setinitialBalancedate(res.data.initialBalanceDate);
                        setinitialBalancedateFormat(res.data.initialBalanceDateFormat);
                        setactualBalance(res.data.actualBalance);
                    }
                });
            }
        
            function LoadTable() {
                setOpenLoadingSimpleBackdrop(true);
                UserService.getAllUserperdirection(selectedDirection).then((res) => {
                  console.log("datapersonne",res.data);
                    if (res && res.status && res.data.length > 0) {
                        setListOfSubordonnate(res.data);
                        BalanceConfigurationService.getLeaveSummaryBalanceBySomeUser(res.data).then((res) => {
                            if (res && res.status) {
                                setDetailListOfSubordonnate(res.data.map((row, index) => ({ ...row, id: index })));
                                setOpenLoadingSimpleBackdrop(false);
                            }
                        });
                    }
                    else{
                        setOpenLoadingSimpleBackdrop(false);
                    }
                });

                
            }
        
            function handleClickExport() {
                var rowsToExport = [];
                var type = 0;

                rowsToExport = detailListOfSubordonnate;
                type = 2;

                BalanceConfigurationService.exportSummaryBalanceByUserConnected(type, rowsToExport, initialBalance, initialBalancedateFormat, actualBalance).then((res) => {
                    if (res && res.status) {
                        const filenameResult = res.data;
                        FileService.readExcelFileContent("Leaves", filenameResult).then((result) => {
                            if (result && result.status) {
                                const data = new Blob([result.data], { type: fileType });
                                FileSaver.saveAs(data, filenameResult);
                            }
                        })
                    }
                })

                const excelData = [

                    {
                       "Numéro": "Numéro",
                      "Nom et Prénoms": "Nom et Prénoms",
                      "Cumul par rapport à une demande de congé": "Cumul par rapport à une demande de congé",
                      "Observation": "Observation",
                      "Date de départ en congé": "Date de départ en congé",
                      "Date de retour en congé": "Date de retour en congé",
                      "Date d'ajout au système": "Date d'ajout au système"
                    },
                    ...rowsToExport.map(person => 
                      person.summaryBalance.map(entry => ({
                        "Numéro": entry.numero,
                        "Nom et Prénoms": `${person.first_name.trim()} ${person.last_name.trim()}`,
                        "Cumul par rapport à une demande de congé": entry.real_balance,
                        "Observation": entry.observation || '',
                        "Date de départ en congé": entry.begin_time,
                        "Date de retour en congé": entry.end_time,
                        "Date d'ajout au système": entry.creation_datetime_format
                      }))
                    ).flat()
                  ];
                  

                  const ws = XLSX.utils.json_to_sheet(excelData, { skipHeader: true });

                  ws['!cols'] = [
                    { wch: 25 }, 
                    { wch: 30 }, 
                    { wch: 40 }, 
                    { wch: 20 },
                    { wch: 20 }, 
                    { wch: 25 }  
                  ];
                  
                  const headers = Object.keys(excelData[0]);
                  for (let colIdx = 0; colIdx < headers.length; colIdx++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIdx });
                    ws[cellAddress] = { t: 's', v: headers[colIdx] };
                    ws[cellAddress].s = {
                      font: { bold: true, color: { rgb: "FFFFFF" } }, 
                      fill: { patternType: "solid", fgColor: { argb: "4472C4" } },
                      alignment: { horizontal: "center", vertical: "center" }
                    };
                  }
                  

                  const wb = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(wb, ws, "Historique du solde");
                  
                  XLSX.writeFile(wb, "historique_solde.xlsx");
                  
            }
        

            const directionOptions = useMemo(() => {
                if (direction.length === 1) return direction;
                return [{ code: 'ALL', name: 'Tous' }, ...direction];
              }, [direction]);
              
              // // Déterminer la valeur par défaut
              // const defaultValue = useMemo(() => {
              //   if (direction.length === 1) return direction[0];
              //   return null;
              // }, [direction]);
              

            const handleDirectionChange = (event, value) => {
                if (!value) {
                  setSelectedDirection(null); 
                } else if (value.code === 'ALL') {
                  setSelectedDirection('all');
                } else {
                  setSelectedDirection(value.direction_id);
                }
              };
            useEffect(() => {
                const userData = localStorage.getItem('USER');
                setOpenLoadingSimpleBackdrop(true);
                if (userData) {
                  UserService.getUserSummaryByUserId(userData)
                    .then((result) => {
                      if (result && result.data) {
                        const dirpers = result.data.direction_id;
                        PlanningMissionService.getDirection().then((result) => {
                          if (result && result.data) {
                            if (parseInt(dirpers, 10) === 1) { 
                              setSelectedDirection(dirpers);
                              setDirection(result.data);
                              
                            } else {
                              setSelectedDirection(dirpers);
                              setDirection(result.data.filter(ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)));
                            }
                          }
                        }).catch((error) => {
                          console.error('Error fetching direction data:', error);
                        });
                      }
                    })
                    .catch((error) => {
                      console.error('Error fetching user summary:', error);
                    });
                }
        
            }, []);
        
            // useEffect(() => {
            //     var userId = localStorage.getItem("USER");
            //     setUserId(userId);
            //     LoadTable();
            //     getInitialActualBalance();
        
            // }, [location]);
        
            useEffect(() => {
                   LoadTable();
                   console.log("aaaa",selectedDirection);
            }, [selectedDirection]);
        
            return (
                <MainContainer {...headerEtat}>
                    <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
                    <Grid container item xs={12}>
                      
                            <Grid item xs={3}>
                            <Autocomplete
                                onChange={handleDirectionChange}
                                name="direction"
                                options={directionOptions}
                                getOptionLabel={(option) => 
                                option.code === 'ALL' ? 'Tous' : `${option.name} (${option.code})`
                                }
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    label="Direction"
                                    placeholder="Rechercher une direction"
                                    InputProps={{ ...params.InputProps, type: 'search' }}
                                />
                                )}
                                value={directionOptions.find(option => option.direction_id === selectedDirection) || null}
                                isOptionEqualToValue={(option, value) => 
                                option.direction_id === value?.direction_id || 
                                (option.code === 'ALL' && value === 'all')
                                }
                                noOptionsText="Aucune direction trouvée"
                                clearOnBlur={false}
                                blurOnSelect
                            />
                                                   
                        </Grid>
                
                        <Grid item xs={3}
                            style={{ fontWeight: 600, marginLeft: "auto" }}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                onClick={handleClickExport}
                                startIcon={<GetAppTwoTone />}
                            >
                                Exporter version excel
                            </Button>
        
                        </Grid>
                    </Grid>
                    <Spacer y={2} />
                    <Grid container spacing={3} item>
                        <Grid item xs={12}>
                            <Paper className={classes.paper} variant="outlined">     
                                    <ListBalance rows={specificListOfSubordonnate.length >0?specificListOfSubordonnate: detailListOfSubordonnate} initialBalancedate={initialBalancedate} />
                            </Paper>
                        </Grid>
                    </Grid>
                    </MainContainer>

    );
}
export default Balancehistory;